import React, { useCallback, useEffect, useState } from "react";
import ToolBar from "../../../components/ToolBar";
import FilterForm from "./Component/FilterForm";
import ListComponent from "./Component/ListComponent";
import { AppDispatch } from "../../../store/app";
import { useDispatch } from "react-redux";
import { getSimList } from "../../../store/SIMManagementSlice";
import { Button } from "antd";
import AddComponent from "./Component/AddComponent";
import EditComponent from "./Component/EditComponent";
import CsvUpload from "./Component/CsvUpload";
import ExportForm from "./Component/ExportForm";

const SIMManagement: React.FC = () => {
  const [listData, setListData] = useState<any>();
  const [totalData, setTotalData] = useState<any>(0);
  const [visible, setVisible] = useState<boolean>(false);
  const [openEditModal, setOpenEditModal] = useState<boolean>(false);
  const [editData, setEditData] = useState();
  const [openCsvModal, setOpenCsvModal] = useState(false);
  const dispatch: AppDispatch = useDispatch();
  const [savePayload, setSavePayload] = useState<any>();
  const [loading, setLoading] = useState(false);
  const [paginationData, setPaginationData] = useState<any>({
    page_number: 1,
    page_size: 10,
  });
  
  const [exportDrawer, setExportDrawer] = useState<boolean>(false);
  const getList = useCallback(
    (data?: any) => {
      setLoading(true);
      const payload = {
        ...data,
        page_number: data?.page_number ?? 1,
        page_size: data?.page_size ?? 10,
      };
      setSavePayload(payload);
      dispatch(getSimList(payload))
        .then((res: any) => {
          setListData(res.data.indexedResults);
          setTotalData(res?.data.totalRecords);
          setLoading(false);
        })
        .catch(() => {
          setListData([]);
          setTotalData(0);
          setLoading(false);
        });
    },
    [dispatch]
  );
  useEffect(() => {
    getList();
  }, [getList]);
  const openAddModal = () => {
    setVisible(true);
  };
  const closeAddModal = () => {
    setVisible(false);
  };
  const handleEditModal = (data: any) => {
    setOpenEditModal(true);
    setEditData(data);
  };
  const closeEditModal = () => {
    setOpenEditModal(false);
  };
  const handleCsvModal = () => {
    setOpenCsvModal(true);
  };
  const closeCsvModal = () => {
    setOpenCsvModal(false);
  };
  const openExportDrawer = () => {
    setExportDrawer(true);
  };
  const closeExportDrawer = () => {
    setExportDrawer(false);
  };



  return (
    <>
      <ToolBar
        title={"SIM Management"}
        children={
          <>
            <Button type="primary" onClick={openAddModal}>
              Add New
            </Button>
            <Button type="default" onClick={openExportDrawer}>
              Export
            </Button>
            <Button type="default" onClick={handleCsvModal}>
              Bulk Add
            </Button>
          </>
        }
      />
      <FilterForm getList={getList} setPaginationData={setPaginationData} />
      <ListComponent
        listData={listData}
        setListData={setListData}
        totalData={totalData}
        tableloading={loading}
        setTableLoading={setLoading}
        paginationData={paginationData}
        setPaginationData={setPaginationData}
        getList={getList}
        savePayload={savePayload}
        handleEditModal={handleEditModal}
      />
      <AddComponent visible={visible} close={closeAddModal} getList={getList} />
      <EditComponent
        visible={openEditModal}
        close={closeEditModal}
        editData={editData}
        getList={getList}
      />
      <CsvUpload
        close={closeCsvModal}
        visible={openCsvModal}
        getList={getList}
      />
      {exportDrawer && (
        <ExportForm
          visible={exportDrawer}
          close={closeExportDrawer}
          savePayload={savePayload}
        />
      )}
      
    </>
  );
};

export default SIMManagement;
